import React from 'react'
import { Form } from 'antd';
import { 
  Grid, 
  TextField,
  Snackbar
} from '@material-ui/core';
import MySnackbarContentWrapper from "../../../components/SnackBar";

class pushForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing..."
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.query_f({ variables: { id: this.props.id, 
          language: values.language,
          message: values.message,
          sendAt: new Date(values.sendAt),
          title: values.title,
          url: values.url, 
          publisherId: localStorage.getItem('publisher-active') } }).then(result =>{
            this.setStateValues(true,"success","Action executed with success!");
            this.props.form.resetFields();
            if(this.props.onCancel){
              this.props.onCancel();
            }
            localStorage.setItem('adireto-drawer-open', false);
          }, error=>{
            this.setStateValues(true,"error","Action executed with error!");          
          });
        }
        else{
          this.setStateValues(true,"error","Form validation failed!");  
        }
      })
    };

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    
    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage}/>
        </Snackbar>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            {getFieldDecorator('title', {
              initialValue: (this.props.title || ''),
              rules: [{ required: true, message: 'Please input your title!', whitespace: true }],
            })(
              <TextField
                id="title"
                label="title"
                color="primary"
                fullWidth
                style={{ marginTop : 13 }}
                InputLabelProps={{
                  shrink : true,
                }}
              />
            )}
          </Grid>
          <Grid item xs={12}>
           {getFieldDecorator('message', {
              initialValue: (this.props.message || ''),
              rules: [{ required: true, message: 'Please input your message!', whitespace: true }],
            })(
              <TextField
                id="message"
                label="Message"
                color="primary"
                fullWidth
                style={{ marginTop : 13 }}
                InputLabelProps={{
                  shrink : true,
                }}
                rows={3}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('language', {
              initialValue: (this.props.language || ''),
              rules: [{ required: true, message: 'Please input your language!', whitespace: true }],
            })(
              <TextField
                id="language"
                label="language"
                color="primary"
                fullWidth
                style={{ marginTop : 13 }}
                InputLabelProps={{
                  shrink : true,
                }}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('sendAt', {
              initialValue: (this.props.sendAt || ''),
              rules: [{ required: true, message: 'Please input your sendAt!', whitespace: true }],
            })(
              <TextField
                id="sendAt"
                label="sendAt"
                color="primary"
                fullWidth
                style={{ marginTop : 13 }}
                InputLabelProps={{
                  shrink : true,
                }}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('url', {
              initialValue: (this.props.url || ''),
              rules: [{ required: true, message: 'Please input your url!', whitespace: true }],
            })(
              <TextField
                id="url"
                label="url"
                color="primary"
                fullWidth
                style={{ marginTop : 13 }}
                InputLabelProps={{
                  shrink : true,
                }}
              />
            )}
          </Grid>
        </Grid>
        </form>
    );
  }
}

const pushNotificationsForm = Form.create()(pushForm);

export default pushNotificationsForm